// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  align-items: center;
  justify-content: center;
}
:host > div {
  display: flex;
  align-items: center;
  justify-content: center;
}
:host .online-button {
  min-width: 35px;
}
:host .online-button .status-text {
  font-size: 11px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/online-indicator/online-indicator.component.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;AACD;AACC;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;AAEC;EACC,eAAA;AAAF;AAEE;EACC,eAAA;AAAH","sourcesContent":[":host {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\t> div {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t}\n\n\t.online-button {\n\t\tmin-width: 35px;\n\n\t\t.status-text {\n\t\t\tfont-size: 11px;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
